import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import SAR from "@componentsShared/SAR/SAR";
import useBoolean from "@hooks/useBoolean";
import { twMerge } from "tailwind-merge";
import useHelpers from "@hooks/useHelpers";
import { useTranslation } from "@i18n";
import { format } from "date-fns";
import SharedPopUp from "@componentsShared/SharedPopUp/SharedPopUp";
import { AnimatePresence } from "framer-motion";
import MobileScreenView from "@componentsShared/mobileScreenView/MobileScreenView";
import useIsMobile from "@hooks/useIsMobile";
import { trackEvents } from "@/common/events/events";
import useBrandsData from "@hooks/useBrandsData";
import { usePriceOfferContext } from "@/common/Contexts/PriceOfferContextProvider";
import PriceOfferProgressBar from "@/pages/price-offer/components/PriceOfferProgressBar";
import Loader from "@componentsShared/Loader/Loader";
import { useState } from "react";
import Markdown from "markdown-to-jsx";
var PriceOfferOfferPage = function PriceOfferOfferPage() {
  var check = useBoolean();
  var screenState = useBoolean(false);
  var isMobile = useIsMobile();
  var _useBrandsData = useBrandsData({
      forcedLang: "en"
    }),
    getMakeById = _useBrandsData.getMakeById,
    getModelById = _useBrandsData.getModelById;
  var _usePriceOfferContext = usePriceOfferContext(),
    constants = _usePriceOfferContext.constants,
    state = _usePriceOfferContext.state,
    selectedCity = _usePriceOfferContext.selectedCity;
  var request_id = state === null || state === void 0 ? void 0 : state.request_id;
  var _useState = useState(false),
    isSubmitting = _useState[0],
    setIsSubmitting = _useState[1];
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort,
    tLong = _useTranslation.tLong;
  var termsModal = useBoolean();
  var data = usePriceOfferContext().state.offerData;
  var _usePriceOfferContext2 = usePriceOfferContext(),
    remote_actions = _usePriceOfferContext2.remote_actions;
  var handlePriceOfferUpdate = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _getMakeById, _getModelById, res, _state$offerData, _selectedCity$allowed, _selectedCity$allowed2, _selectedCity$inspect;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (!isSubmitting) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            setIsSubmitting(true);
            _context.p = 2;
            trackEvents("offer_accepted", {
              car_make: (_getMakeById = getMakeById(Number(data === null || data === void 0 ? void 0 : data.make_id))) === null || _getMakeById === void 0 ? void 0 : _getMakeById.name,
              car_model: ((_getModelById = getModelById(Number(data === null || data === void 0 ? void 0 : data.model_id))) === null || _getModelById === void 0 ? void 0 : _getModelById.name) || "",
              car_year: data === null || data === void 0 ? void 0 : data.year,
              offer_amount: data === null || data === void 0 ? void 0 : data.offer_price
            });
            _context.n = 3;
            return remote_actions.fetch_priceOfferAccept();
          case 3:
            res = _context.v;
            if (!(res !== null && res !== void 0 && res.success)) {
              _context.n = 9;
              break;
            }
            if (state !== null && state !== void 0 && (_state$offerData = state.offerData) !== null && _state$offerData !== void 0 && _state$offerData.allow_booking_final_appointment) {
              _context.n = 4;
              break;
            }
            return _context.a(2, navigateTo(constants.success_url(state === null || state === void 0 ? void 0 : state.request_id)));
          case 4:
            if (!(selectedCity !== null && selectedCity !== void 0 && selectedCity.approved_for_inspection)) {
              _context.n = 8;
              break;
            }
            if (!((selectedCity === null || selectedCity === void 0 ? void 0 : (_selectedCity$allowed = selectedCity.allowed_inspection_location[0]) === null || _selectedCity$allowed === void 0 ? void 0 : (_selectedCity$allowed2 = _selectedCity$allowed.customer_location) === null || _selectedCity$allowed2 === void 0 ? void 0 : _selectedCity$allowed2.status) === "True")) {
              _context.n = 5;
              break;
            }
            return _context.a(2, navigateTo(constants.inspection_user_location_url(request_id)));
          case 5:
            if (!((selectedCity === null || selectedCity === void 0 ? void 0 : (_selectedCity$inspect = selectedCity.inspection_location) === null || _selectedCity$inspect === void 0 ? void 0 : _selectedCity$inspect.length) === 1)) {
              _context.n = 6;
              break;
            }
            return _context.a(2, navigateTo(constants.inspection_location_single_url(request_id)));
          case 6:
            return _context.a(2, navigateTo(constants.inspection_location_url(request_id)));
          case 7:
            _context.n = 9;
            break;
          case 8:
            return _context.a(2, navigateTo(constants.success_url(request_id)));
          case 9:
            _context.p = 9;
            setIsSubmitting(false);
            return _context.f(9);
          case 10:
            return _context.a(2);
        }
      }, _callee, null, [[2,, 9, 10]]);
    }));
    return function handlePriceOfferUpdate() {
      return _ref.apply(this, arguments);
    };
  }();
  sessionStorage.setItem("inOfferPage", JSON.stringify(true));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PriceOfferProgressBar, null), /*#__PURE__*/React.createElement("div", {
    className: "md:flex md:flex-col md:gap-12 pt-2 md:pt-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6 md:gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-start mb-6 flex flex-col gap-2 md:mb-0"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-[24px] font-bold text-primary flex items-center gap-1"
  }, /*#__PURE__*/React.createElement("span", null, tShort("price_offer/offer_seller_greeting", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("span", null, data === null || data === void 0 ? void 0 : data.seller_name)), /*#__PURE__*/React.createElement("p", {
    className: "text-gray-causeway text-base leading-relaxed"
  }, tShort("price_offer/offer_seller_description", {
    ns: "web_sell_trade"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "border border-solid border-success-70 rounded-lg p-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-0.5 pb-2 border-b border-solid border-[#ECF3FD]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-xs font-medium text-neutral-30"
  }, tShort("price_offer/offer_can_title", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-xs font-medium text-neutral-30"
  }, tShort("price_offer/offer_price", {
    ns: "web_sell_trade"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-sm font-bold text-netural-90 leading-relaxed"
  }, data === null || data === void 0 ? void 0 : data.title), /*#__PURE__*/React.createElement("p", {
    className: "flex items-center gap-0.5"
  }, /*#__PURE__*/React.createElement("span", {
    className: "font-bold text-success text-base"
  }, data === null || data === void 0 ? void 0 : data.offer_price), /*#__PURE__*/React.createElement(SAR, {
    className: "font-bold text-success text-base"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center pt-2"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-neutral-30 text-xs font-medium"
  }, tShort("price_offer/offer_expiry_date", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-neutral-30 text-xs font-bold"
  }, (data === null || data === void 0 ? void 0 : data.offer_expiry_date) && format(new Date(data === null || data === void 0 ? void 0 : data.offer_expiry_date), 'yyyy-MM-dd'))))), /*#__PURE__*/React.createElement("div", {
    className: "font-regular text-neutral-90 text-sm flex items-center gap-0.5"
  }, /*#__PURE__*/React.createElement("p", null, tShort("price-offer/consent-text", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-primary-new underline cursor-pointer",
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      if (isMobile) {
        screenState.setTrue();
      } else {
        termsModal.setTrue();
      }
    }
  }, tShort("price-offer/consent-active", {
    ns: "web_common"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "absolute bottom-0 w-full left-0 px-4 py-6 md:relative md:p-0 md:pt-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full flex flex-col gap-4 md:flex-row-reverse md:gap-3 md:justify-start"
  }, /*#__PURE__*/React.createElement("button", {
    className: twMerge("transition-colors duration-200 ease-in ", "w-full p-3 bg-primary text-white rounded text-center font-bold border-none outline-none text-base md:max-w-[200px] cursor-pointer hover:bg-primary-120 transition-colors duration-200 ease-in", "disabled:bg-[#E8EFF6] disabled:text-[#92A5C1] disabled:cursor-not-allowed disabled:pointer-events-none", "relative"),
    disabled: isSubmitting,
    onClick: function onClick() {
      handlePriceOfferUpdate().then();
    }
  }, tShort("price_offer/offer_accept_button", {
    ns: "web_sell_trade"
  }), isSubmitting && /*#__PURE__*/React.createElement(Loader, {
    className: "!absolute !inset-0 !w-auto !h-auto !bg-transparent [&>span]:!w-5 [&>span]:!h-5 [&>span]:!border-2 [&>span]:after:!w-5 [&>span]:after:!h-5 [&>span]:after:!border-2"
  })), /*#__PURE__*/React.createElement("button", {
    className: "w-full p-3 bg-white text-gray-text rounded text-center font-bold border-none outline-none text-base md:max-w-[200px] cursor-pointer md:hover:bg-danger md:hover:text-white transition-colors duration-200 ease-in",
    onClick: function onClick() {
      navigateTo(constants.reject_url(request_id));
    }
  }, tShort("price_offer/offer_reject_button", {
    ns: "web_sell_trade"
  }))))), /*#__PURE__*/React.createElement(SharedPopUp, {
    show: termsModal.value,
    onClose: function onClose() {
      termsModal.setFalse();
    },
    oowh: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-8 flex flex-col gap-6"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-primary text-center text-[24px] font-bold"
  }, tShort("price_offer/offer_terms_popup_title", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-[#6C7A8D] font-sm text-start font-regular leading-relaxed"
  }, /*#__PURE__*/React.createElement(Markdown, null, tLong("price_offer/offer_terms_popup_content", {
    ns: "web_sell_trade"
  }))))), /*#__PURE__*/React.createElement(AnimatePresence, null, screenState.value && /*#__PURE__*/React.createElement(MobileScreenView, {
    onClose: screenState.setFalse,
    title: tShort("price_offer/offer_terms_popup_title", {
      ns: "web_sell_trade"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-[#6C7A8D] font-sm text-start font-regular leading-relaxed"
  }, /*#__PURE__*/React.createElement(Markdown, {
    className: twMerge("text-black-primary text-sm font-medium [&>strong]:font-black [&>strong]:text-black-primary leading-relaxed", "[&>h1]:text-lg [&>h2]:text-base [&>h1]:mt-4 [&>h1]:mb-2 [&>h2]:mt-4 [&>h2]:mb-2 [&>h2]:font-bold [&>h1]:font-bold", "[&>p]:text-sm [&>p]:mx-2 [&>p]:text-gray-text [&>p]:font-medium [&>ul>li]:text-sm [&>ul>li]:mx-2 [&>ul>li]:text-gray-text [&>ul>li]:font-medium", "[&>ul]:list-disc [&>ul]:ps-4 [&>ul>li]:py-1")
  }, tLong("price_offer/offer_terms_popup_content", {
    ns: "web_sell_trade"
  }))))));
};
export default PriceOfferOfferPage;